<div class="modal-header">
	<h4 class="modal-title fw-bold">
		<span jhiTranslate="germplasm.import.matches.header"></span><span *ngIf="hasForceCreatePermission()" jhiTranslate="germplasm.import.matches.header.add.new.entry"></span>
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal" aria-hidden="true"
			(click)="dismiss()">
	</button>
</div>
<div class="modal-body">
	<div>
		<div class="row mb-sm-3">
			<div class="col">
				<span jhiTranslate="germplasm.import.matches.matches.were.found" [translateValues]="{param1: entryNo, param2: matchNumber, param3: unassignedCount}"></span>
				<span jhiTranslate="germplasm.import.matches.click.on.an.entry"></span>
			</div>
		</div>
		<div class="row">
			<div class="col">
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-curved">
						<thead>
						<th jhiTranslate="germplasm.import.matches.column.gid">GID</th>
						<th jhiTranslate="germplasm.import.matches.column.name">PREFERRED NAME</th>
						<th jhiTranslate="germplasm.import.matches.column.names">NAMES</th>
						<th jhiTranslate="germplasm.import.matches.column.cross">CROSS</th>
						<th jhiTranslate="germplasm.import.matches.column.loc">LOCATION</th>
						<th jhiTranslate="germplasm.import.matches.column.bmethod">BREEDING METHOD</th>
						<th jhiTranslate="germplasm.import.matches.column.cdate">CREATION DATE</th>
						</thead>
						<tbody>
						<tr [@tableAnimation] *ngFor="let germplasm of matches | slice: (page-1) * pageSize : page * pageSize"
							[class.selected]="selectMatchesResult[dataRow[HEADERS.ENTRY_NO]] == germplasm.gid"
							(click)="onSelectMatch(germplasm)">
							<td><a class="link" (click)="germplasmDetailsPopupService.open(germplasm.gid)">{{germplasm.gid}}</a></td>
							<td><a class="link" (click)="germplasmDetailsPopupService.open(germplasm.gid)">{{germplasm.preferredName}}</a></td>
							<td><span *ngFor="let name of germplasm.names; let last = last">{{name.name}}<span *ngIf="!last">, </span></span></td>
							<td>{{germplasm.pedigreeString}}</td>
							<td>{{germplasm.breedingLocation}}</td>
							<td>{{germplasm.breedingMethod}}</td>
							<td>{{germplasm.creationDate}}</td>
						</tr>
						</tbody>
					</table>
				</div>
				<div class="row">
					<div class="col">
						<div class="pagination-container">
							<div class="pagination-box pagination-box-left">
								<div>
									<jhi-item-count [page]="page" [total]="matches.length" [itemsPerPage]="pageSize"></jhi-item-count>
								</div>
							</div>
							<div class="pagination-box">
								<ngb-pagination [collectionSize]="matches.length" [(page)]="page" [pageSize]="pageSize"
												[maxSize]="5" [rotate]="true" [boundaryLinks]="true"></ngb-pagination>
							</div>
							<div class="pagination-box pagination-box-right">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col">
				<div class="form-check form-check-inline">
					<input type="checkbox" class="form-check-input" name="useSameMatchForAllOccurrences" id="useSameMatchForAllOccurrences"
						   [(ngModel)]="useSameMatchForAllOccurrences" [disabled]="isIgnoreAllRemaining"
						   (change)="onUseSameMatchForAllOccurrences()">
					<label class="form-check-label" for="useSameMatchForAllOccurrences" jhiTranslate="germplasm.import.matches.use.same.match.for.all.occurrences">
					</label>
				</div>
			</div>
		</div>
		<div class="row mb-3" *ngIf="hasForceCreatePermission()">
			<div class="col">
				<div class="form-check form-check-inline">
					<input type="checkbox" class="form-check-input" name="ignoreMatch" id="ignoreMatch"
						   [(ngModel)]="isIgnoreMatch" [disabled]="isIgnoreAllRemaining"
						   (change)="onIgnoreMatch()">
					<label class="form-check-label" for="ignoreMatch" jhiTranslate="germplasm.import.matches.ignore.match">
					</label>
				</div>
			</div>
		</div>
		<div class="row mb-3" *ngIf="hasForceCreatePermission()">
			<div class="col">
				<div class="form-check form-check-inline">
					<input type="checkbox" class="form-check-input" name="ignoreAllRemaining" id="ignoreAllRemaining"
						   [(ngModel)]="isIgnoreAllRemaining"
						   (change)="onIgnoreAllRemaining()">
					<label class="form-check-label" for="ignoreAllRemaining" jhiTranslate="germplasm.import.matches.ignore.all.remaining">
					</label>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="modal-footer">
	<button *ngIf="assignedMatchIndexes.length === 0" type="button" class="btn btn-secondary" data-bs-dismiss="modal"
			(click)="dismiss()">
		<span jhiTranslate="cancel"></span>
	</button>
	<button *ngIf="matchIndex > 0" type="button" class="btn btn-secondary"
			(click)="back()">
		<span jhiTranslate="back"></span>
	</button>
	<button (click)="next()" class="btn btn-primary" [disabled]="!(isIgnoreAllRemaining || isIgnoreMatch || selectMatchesResult[dataRow[HEADERS.ENTRY_NO]])"
			data-test="importGermplasmMatchesButton">
		<span *ngIf="isFinish(); else nextButton" jhiTranslate="finish"></span>
		<ng-template #nextButton><span jhiTranslate="next"></span></ng-template>
	</button>
</div>
